module.exports = __webpack_public_path__ + "img/gallery_1.9a5e7193.jpg";